/**
 * 봇 탐지 유틸리티
 * 
 * AI 크롤러와 일반 검색 봇을 탐지하여 Analytics 이벤트 수집에서 제외
 */

/**
 * 알려진 봇 User Agent 패턴
 */
const BOT_PATTERNS = [
    // AI 크롤러
    /GPTBot/i,
    /ChatGPT/i,
    /CCBot/i,
    /anthropic/i,
    /Claude/i,
    /Google-Extended/i,
    /PerplexityBot/i,
    /Omgilibot/i,
    /FacebookBot/i,
    /Diffbot/i,

    // 일반 검색 크롤러
    /Googlebot/i,
    /bingbot/i,
    /Slurp/i,
    /DuckDuckBot/i,
    /Baiduspider/i,
    /YandexBot/i,
    /Sogou/i,
    /Exabot/i,
    /facebot/i,
    /ia_archiver/i,

    // 기타 봇
    /bot/i,
    /crawl/i,
    /spider/i,
    /slurp/i,
    /scraper/i,
    /curl/i,
    /wget/i,
    /python-requests/i,
    /axios/i,
    /node-fetch/i,
];

/**
 * 화이트리스트 패턴 (봇처럼 보이지만 허용할 것들)
 */
const WHITELIST_PATTERNS = [
    /Chrome\/\d+\.0\.0\.0.*Safari/i,  // 정상 Chrome 브라우저
    /Firefox\/\d+/i,                   // 정상 Firefox 브라우저
    /Safari\/\d+/i,                    // 정상 Safari 브라우저
    /Edge\/\d+/i,                      // 정상 Edge 브라우저
];

/**
 * User Agent가 봇인지 확인
 */
export function isBot(userAgent?: string): boolean {
    if (!userAgent) return true;

    // 1. 화이트리스트 먼저 체크 (정상 브라우저)
    const isWhitelisted = WHITELIST_PATTERNS.some(pattern =>
        pattern.test(userAgent)
    );

    // 2. 화이트리스트에 있어도 봇 패턴이 명확하면 봇으로 간주
    const hasExplicitBotPattern = BOT_PATTERNS.some(pattern =>
        pattern.test(userAgent)
    );

    // 화이트리스트에 있고 명확한 봇 패턴이 없으면 정상 사용자
    if (isWhitelisted && !hasExplicitBotPattern) {
        return false;
    }

    // 봇 패턴 매칭
    return hasExplicitBotPattern;
}

/**
 * 현재 환경이 브라우저인지 확인
 */
export function isBrowser(): boolean {
    return typeof window !== 'undefined' && typeof navigator !== 'undefined';
}

/**
 * 현재 사용자가 봇인지 확인 (브라우저 환경에서만)
 */
export function isCurrentUserBot(): boolean {
    if (!isBrowser()) return false;

    return isBot(navigator.userAgent);
}

/**
 * 디버그용: 현재 User Agent 정보 출력
 */
export function debugUserAgent(): void {
    if (!isBrowser()) {
        console.log('[Bot Detector] Not in browser environment');
        return;
    }

    const ua = navigator.userAgent;
    const detected = isBot(ua);

    console.log('[Bot Detector] User Agent Analysis:', {
        userAgent: ua,
        isBot: detected,
        timestamp: new Date().toISOString(),
    });
}

